<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-form inline class="inline-form">
        <el-form-item label="关联时间">
          <date-range-picker v-model="relatedTime" :value="relatedTime" @getChange="dateChange"></date-range-picker>
        </el-form-item>
        <el-form-item label="商户编号">
          <el-input class="search-input" v-model="searchInfo.secondMerchantId" placeholder="请输入商户编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="loading"></auth-button>
            <auth-button
              opt="open"
              @click.native="openSubAccount"
              :loading="openFormLoading"
              label="功能开通"></auth-button>
            <auth-button
              opt="relate"
              @click.native="relateDialogVisible = true"
              label="关联收款方"></auth-button>
          </el-form-item>
      </el-form>
    </el-card>
    <!-- table -->
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        :data="list"
        v-loading="loading"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="createTime"
          label="关联时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户名称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantType"
          label="企业类型"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <auth-button opt="update" type="text" @click.native="unBind(scope.row)" label="解除关联"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      :visible.sync="openDialogVisible"
      width="50%"
      @close="clearInfo"
      :close-on-click-modal="false">
      <div slot="title" class="dialog-title">功能开通<span class="tips">以下两种方式支持开通，二选一即可</span></div>
      <div :class="statusColor" class="status" v-show="openForm.shareType !== 0"><i class="el-icon-warning-outline" :class="statusColor"></i>{{openForm.shareTypeStr}}</div>
      <el-form ref="openForm" :model="openForm" :rules="ruleData" class="openForm">
        <el-form-item prop="sharePercent">
          <div class="input-item">
            <span class="label spec">设置比例</span>
            <el-input class="rate-input" v-model="openForm.sharePercent" placeholder="请设置比例，不传取代理商默认比例" :disabled="openForm.shareType !== 0"><template slot="append">%</template></el-input>
          </div>
        </el-form-item>
        <el-radio-group v-model="openForm.contractType">
          <el-form-item prop="contractImg">
            <div class="input-item">
              <el-radio :label="0" class="label" :disabled="!!openForm.contractUrl">纸质合同</el-radio>
              <upload-img-ele
                v-model="openForm.contractImg"
                :value="openForm.contractImg"
                :disabled="!!openForm.contractUrl || openForm.shareType !== 0"
                @upload="data => openForm.contractImg = data.path">
              </upload-img-ele>
              <a href="static/特约商户支付服务合作协议--商户分账补充协议.docx" download class="link download">下载模板</a>
            </div>
          <div class="desc">请上传授权协议</div>
          </el-form-item>
          <div class="input-item">
            <el-radio :label="1" class="label" :disabled="openForm.shareType !== 0">电子合同</el-radio>
            <el-button v-show="!openForm.contractUrl" type="text" :loading="elecLoading" @click="getContractUrl" :disabled="openForm.shareType !== 0">获取签署码</el-button>
            <div v-show="openForm.contractUrl" id="img_box"></div>
          </div>
          <div v-if="openForm.contractUrl" class="desc">请扫码完成签署</div>
        </el-radio-group>
      </el-form>
      <div slot="footer" class="dialog-footer" v-show="openForm.shareType === 0">
        <el-button @click="clearInfo">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="openLoading">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="relateDialogVisible"
      width="50%"
      title="关联收款方"
      @close="clearRelateInfo"
      :close-on-click-modal="false">
      <div class="input-item next">
        <span class="label"><span class="required">*</span>商户编号</span>
        <el-input type="textarea" class="merchant-input" v-model="merchantIds" placeholder="请输入商户编号，多个编号用逗号隔开" :autosize="{ minRows: 3, maxRows: 5}"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearRelateInfo">取消</el-button>
        <el-button type="primary" @click="handleRelate" :loading="relateLoading">确定</el-button>
      </div>
    </el-dialog>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNumber" :size="paginations.pageSize"></pagination>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { accredit, elecContractAccredit, accreditQuery, pageBind, subAccountBind, subAccountUnBind } from '@/api/subAccount.js'
import uploadImgEle from '@/components/upload/uploadImgEle'

export default {
  name: 'RelatedPayee',
  components: {
    dateRangePicker,
    pagination,
    uploadImgEle
  },
  data () {
    return {
      loading: false, // 表单加载状态
      elecLoading: false, // 获取电子合同加载状态
      relateLoading: false, // 关联加载状态
      openLoading: false, // 功能开通 加载状态
      openFormLoading: false, // 功能开通
      // 需要给分页组件传的信息
      paginations: {
        pageNumber: 1,
        count: 0,
        pageSize: 10
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        secondMerchantId: ''
      },
      openForm: {
        contractType: 0,
        contractImg: '',
        contractUrl: '',
        sharePercent: '',
        shareType: 0,
        shareTypeStr: ''
      },
      list: [],
      openDialogVisible: false,
      relateDialogVisible: false,
      relatedTime: [],
      merchantIds: '',
      qrcode: '',
      ruleData: {
        contractImg: [{
          required: true,
          message: '请上传纸质合同图片',
          trigger: 'change'
        }],
        sharePercent: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入分成比例'))
            } else if (/^[\d]{1,2}(\.[\d]{1,2})?$/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入合适的分成比例'))
            }
          },
          required: true,
          trigger: 'change'
        }]
      }
    }
  },
  mounted () {
    this.getDefaultData()
  },
  computed: {
    statusColor () {
      let color
      // 合同状态（0,"未开通"）(1,"已开通")(2,"商户主动关闭")(3,"待审核")(4,"冻结")(5,"注销")(6,"待签署电子合同")
      switch (this.openForm.shareType) {
        case 4:
        case 5: {
          color = 'red'
          break
        }
        case 1: {
          color = 'green'
          break
        }
        default: {
          color = 'yellow'
        }
      }
      return color
    }
  },
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      this.paginations.pageNumber = 1
      await this.searchClick()
    },

    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNumber = page
      this.searchClick()
    },

    dateChange (value) {
      this.relatedTime = value
    },
    /**
     * 订单计费明细查询
     */
    searchClick () {
      this.loading = true
      this.searchInfo.startTime = this.relatedTime && this.relatedTime[0] ? this.relatedTime[0] : ''
      this.searchInfo.endTime = this.relatedTime && this.relatedTime[1] ? this.relatedTime[1] : ''
      const params = qs.stringify(Object.assign({}, this.searchInfo, this.paginations))
      pageBind(params).then(response => {
        this.loading = false
        if (response.error_code === '0') {
          this.list = response.data.list
          this.paginations.count = response.data.total
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error',
            showClose: true
          })
        }
      })
    },

    handleSubmit () {
      // 纸质合同
      if (this.openForm.contractType === 0) {
        this.$refs.openForm.validate(valid => {
          if (valid) {
            accredit(qs.stringify({
              sharePercent: this.openForm.sharePercent * 100,
              shareProtocolPic: this.openForm.contractImg
            })).then(res => {
              if (res.error_code === '0') {
                this.$message({
                  message: '开通成功',
                  type: 'success',
                  showClose: true
                })
                this.openDialogVisible = false
              } else {
                this.$message({
                  message: res.error_msg,
                  type: 'error',
                  showClose: true
                })
              }
            })
          }
        })
      } else {
        // 电子合同
        this.openDialogVisible = false
      }
    },

    getContractUrl () {
      if (this.elecLoading) {
        return
      }
      if (!this.openForm.sharePercent) {
        this.$message({
          message: '请先设置分润比例',
          type: 'error',
          showClose: true
        })
        return
      }
      this.$confirm('获取签署码后无法上传纸质合同，是否获取签署码？', '提示', {}).then(() => {
        this.elecLoading = true
        elecContractAccredit(qs.stringify({
          sharePercent: this.openForm.sharePercent * 100
        })).then(res => {
          this.elecLoading = false
          if (res.error_code === '0') {
            this.openForm.contractUrl = res.data.contractUrl
            this.qrcode = new QRCode(document.getElementById('img_box'), {
              width: 120, // 设置宽高
              height: 120
            })
            this.qrcode.clear()
            this.qrcode.makeCode(this.openForm.contractUrl)
          } else {
            this.$message({
              message: res.error_msg,
              type: 'error',
              showClose: true
            })
          }
        })
      })
    },

    handleRelate () {
      console.log(/^\d+(,\d+)*$/.test(this.merchantIds))
      if (!/^\d+(,\d+)*$/.test(this.merchantIds)) {
        this.$message({
          message: '请按格式输入商户编号'
        })
      } else {
        this.relateLoading = true
        subAccountBind(qs.stringify({ merchantIds: this.merchantIds })).then(res => {
          this.relateLoading = false
          if (res.error_code === '0') {
            this.$message({
              message: '关联成功',
              type: 'success',
              showClose: true
            })
            this.relateDialogVisible = false
            this.searchClick()
          } else {
            this.$message({
              message: res.error_msg,
              type: 'error',
              showClose: true
            })
          }
        })
      }
    },

    clearInfo () {
      this.openForm.contractType = 0
      this.openForm.contractImg = ''
      this.openForm.contractUrl = ''
      this.openForm.sharePercent = ''
      this.openDialogVisible = false
      this.qrcode = ''
    },
    clearRelateInfo () {
      this.relateDialogVisible = false
      this.merchantIds = ''
    },
    openSubAccount () {
      this.openFormLoading = true
      accreditQuery().then(res => {
        this.openFormLoading = false
        if (res.error_code === '0') {
          this.openDialogVisible = true
          this.openForm.shareType = res.data.shareType
          this.openForm.shareTypeStr = res.data.shareTypeStr
          if (res.data.shareType === 6) {
            this.$nextTick(() => {
              this.openForm.contractType = 1
              this.openForm.contractUrl = res.data.contractUrl
              document.getElementById('img_box').innerHTML = ''
              this.qrcode = new QRCode(document.getElementById('img_box'), {
                width: 120, // 设置宽高
                height: 120
              })
              this.qrcode.clear()
              this.qrcode.makeCode(this.openForm.contractUrl)
            })
            this.$refs.openForm.clearValidate()
          }
        }
      }, () => { this.openFormLoading = false }).catch((e) => {
        this.openFormLoading = false
      })
    },

    unBind (row) {
      this.$confirm('是否确认解除关联？', '提示', {}).then(() => {
        subAccountUnBind(qs.stringify({
          merchantIds: row.merchantId
        })).then(res => {
          if (res.error_code === '0') {
            this.$message({
              message: '解除成功',
              type: 'success',
              showClose: true
            })
            this.searchClick()
          } else {
            this.$message({
              message: res.error_msg,
              type: 'error',
              showClose: true
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.dialog-title {
  font-size: 18px;
  .tips {
    color: #C0C4CC;
    font-size: 14px;
    padding-left: 16px;
  }
}
.input-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  margin-top: 36px;
  &.next {
    margin-top: 0;
  }
  .label {
    color: #606266;
    width: 90px;
    &.spec {
      box-sizing: border-box;
      padding-left: 22px;
      margin-right: 30px;
    }
    .required {
      color: red;
      margin-right: 4px;
    }
  }
  .rate-input {
    width: 320px;
  }
  .merchant-input {
    width: 520px;
  }
  .link {
    color: #409eff;
    cursor:pointer;
    &.download {
      margin-left: 12px;
    }
  }
}
.desc {
  font-size: 12px;
  // margin-bottom: 20px;
  margin-left: 120px;
  color: #c0c4cc;
}
.dialog-footer {
  text-align: center;
}
.status {
  margin-bottom: 24px;
  margin-left: 22px;
  font-size: 18px;
  i {
    padding-right: 8px;
  }
  &.red{
    color: #ff7070;
  }
  &.green{
    color: #77d580;
  }
  &.yellow{
    color: #E6A23C;
  }
}
/deep/ .openForm {
  .el-form-item__error {
    padding-left: 120px;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
#img_box {
  margin-bottom: 12px;
}
</style>
